<template>
  <div>
    <h3>Account</h3>
    <div :class="{ loading: formIsLoading }" class="form-group">
      <Result v-model:error="formError" v-model:is-success="formIsSuccess" />
      <div class="form-section">
        <div class="form-row">
          <input v-model="formName" type="text" maxlength="100" required placeholder="Full Name" title="Full Name" />
        </div>
        <div class="form-row">
          <input v-model="formEmail" type="email" maxlength="100" required placeholder="Email" title="Email" />
        </div>
        <div class="form-row">
          <input v-model="formPassword" type="password" maxlength="25" placeholder="Password - leave blank to keep existing" />
        </div>
        <a @click="formIsCollaborator = !formIsCollaborator">{{ formIsCollaborator ? "Remove Collaborator" : "Add Collaborator" }}</a>
      </div>
      <div v-if="formIsCollaborator" class="form-section">
        <h4>Add Collaborator</h4>
        <p class="infomsg">A collaborator is user account that is added to all of your trips. You may add an assistant, a manager or anyone or any system with a user account. Please keep in mind, this person or system will have access to your personal information and trip discussions.</p>
        <div class="form-row">
          <select v-model="formCollaborator">
            <option :value="null">No collaborator</option>
            <option v-for="c in formColleagues" :key="c.customer_id" :value="c.customer_id">
              {{ c.customer_name }}
            </option>
          </select>
        </div>
      </div>
      <button @click="save">Save Account</button>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, watch } from "vue";
import Result from "./common/FormResult.vue";
import useApi from "../utils/apiCalls.js";

// Emits
const emit = defineEmits(["error"]);

// State
const formName = ref(null);
const formEmail = ref(null);
const formPassword = ref(null);
const formColleagues = ref([]);
const formCollaborator = ref(null);
const formIsCollaborator = ref(false);
const formIsLoading = ref(true);
const formIsSuccess = ref(false);
const formError = ref(null);

// API Utilities
const { apiGetRequest, apiPutRequest } = useApi(emit);

// Watcher
watch(formIsCollaborator, value => {
  if (!value) {
    formCollaborator.value = null;
    save();
  }
});

// Load data on component mount
onMounted(() => {
  load();
  loadAll();
});

// Methods
const load = () => {
  formIsLoading.value = true;

  apiGetRequest({
    path: "/customers",
    onSuccess: data => {
      formName.value = data.name;
      formEmail.value = data.email;
      formCollaborator.value = data.collaborator_id;
      formIsLoading.value = false;

      if (formCollaborator.value !== null) {
        formIsCollaborator.value = true;
      }
    },
    onError: error => {
      formError.value = error;
      formIsLoading.value = false;
      emit("error", error);
    },
  });
};

const loadAll = () => {
  apiGetRequest({
    path: "/customer-colleagues",
    onSuccess: data => {
      formColleagues.value = data;
      load();
    },
    onError: error => {
      formIsLoading.value = false;
      emit("error", error);
    },
  });
};

const save = () => {
  formIsLoading.value = true;

  apiPutRequest({
    path: "/customers",
    data: {
      name: formName.value,
      email: formEmail.value,
      password: formPassword.value ? formPassword.value : null,
      collaborator_id: formCollaborator.value ? Number(formCollaborator.value) : null,
    },
    onSuccess: () => {
      formIsSuccess.value = true;
      formError.value = null;
      formIsLoading.value = false;
    },
    onError: error => {
      formIsSuccess.value = false;
      formError.value = error;
      formIsLoading.value = false;
      emit("error", error);
    },
  });
};
</script>
